<template>
  <RightsDisplayButton
    v-if="isCurrentUserPm"
    :rights="accessRights"
    :isClickable="isCurrentUserPm"
    :disableButton="!isCurrentUserPm"
    @click="onOpenChecklistPane"
    compact
  />
</template>

<script lang="ts">
import { mapActions, mapGetters } from 'vuex'

import RightsDisplayButton from '@/common/users/RightsDisplayButton.vue'
import { OPEN_CHECKLIST_PANE } from '@/store/modules/checklist/action_types'

export default {
  name: 'ChecklistTableTaskShortcutRights',

  components: {
    RightsDisplayButton,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
    parent: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters('room', ['isCurrentUserPm']),
    accessRights() {
      const users = this.item?.['simpleRights']?.users || [];
      const groups = this.item?.['simpleRights']?.groups || [];
      const shareType = this.item?.['simpleRights']?.isPublic || ''

      return {
        users: users,
        groups: groups,
        isPublic: shareType,
      }
    },
  },

  methods: {
    ...mapActions('checklist', [OPEN_CHECKLIST_PANE]),

    onOpenChecklistPane() {
      this.OPEN_CHECKLIST_PANE({
        isOpen: true,
        parent: this.parent,
        tab: 'rights',
        tasks: [this.item],
      })
    },
  },
}
</script>
